import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Gradient = _resolveComponent("Gradient")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Space = _resolveComponent("Space")!

  return (_openBlock(), _createBlock(_component_Space, {
    vertical: "",
    full: ""
  }, {
    default: _withCtx(() => [
      (_ctx.showDetails && _ctx.modelValue.length > 0)
        ? (_openBlock(), _createBlock(_component_Gradient, {
            key: 0,
            "model-value": _ctx.modelValue,
            "base-color": _ctx.baseColor,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }, null, 8 /* PROPS */, ["model-value", "base-color"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_Checkbox, {
        name: "グラデーション",
        "model-value": _ctx.modelValue.length > 0,
        "onUpdate:modelValue": _ctx.toggle
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString("グラデーション"))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"])
    ]),
    _: 1 /* STABLE */
  }))
}